import React, { useState } from 'react';
import { useAtomValue } from 'jotai';
import { userInfoAtom } from '../../../data/atoms/utilsAtoms';
import VideoCardPlaylist from '../../../v2/components/VideoCardPlaylist';
import { useSavedVideos } from '../../../v2/pages/PersonalPlayList/hooks/useSavedVideos';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import SaveIcon from '@mui/icons-material/Save';
import EditIcon from '@mui/icons-material/Edit';
import ShuffleIcon from '@mui/icons-material/Shuffle';
import ReorderPlaylistComponent from '../../../v2/components/Playlist/ReorderPlaylistComponent';
import { Playlist } from '../../../constants/Playlist';
import { Users } from '@/constants/Users';




const DisplayPlaylistVideos = ({ currentVideos, fld, index, handleShuffle, handleDeleteVideo, onEdit, onDelete, onSave, onReorderClicked, onReorder, isReordering, subscriptionStatus }) => {
	const userInfo = useAtomValue(userInfoAtom);
	const [shuffleClicked, setShuffleClicked] = useState(false);

	const { savedVideos, handleSaveUnsave } = useSavedVideos(userInfo);
	const handleEdit = e => {
		e.preventDefault();
		onEdit(e, fld);
	}
	const handleSave = e => {
		e.preventDefault();
		onSave()
	}
	const handleReorder = e => {
		e.preventDefault();
		onReorderClicked(e, fld?.videos || [])
	}
	const onShuffle = e => {
		e.preventDefault()
		setShuffleClicked(true)
		handleShuffle(e, fld)

		setTimeout(() => {
			setShuffleClicked(false)
		}, 7000)
	}
	const displayVideos = Array.isArray(currentVideos) && currentVideos.length > 0 ? currentVideos : [];
	const hasEditAccess = userInfo?.user?.userType !== Users.subUser
	return (
		<>
			<div
				className="c-video c-video_feature-box update updated__play__card__list "
				style={{ backgroundColor: 'var(--dark)' }}
			>
				{fld ? (
					<div className="row m-0 mt-2 list_id_pt_top position-relative " key={index}>
						<div className=" position-absolute start-0 w-100 " style={{ top: '-100px' }} id={index}></div>
						<div className="col-md-12 p-0">
							<div className="c-featured_box-right">
								<div className="d-flex justify-content-between align-items-center gap-2 mb-2">
									<div className="d-flex flex-row gap-1 align-content-center mb-0 ">
										<p className='playlist_name'>{fld?.name}</p>
										<div className='d-flex' onClick={handleEdit}>{isReordering && (<EditIcon style={{ color: '#3cb4e4' }} />)}</div>
									</div>
									<div className="c-featured_box-left-b4 m-0 d-inline-flex align-items-center">
										{hasEditAccess && (
											isReordering ? (
												<button onClick={handleEdit} className="d-flex align-content-center outline__primary__btn shuffle fw-normal small">
													<span>
														<PlaylistAddIcon style={{ color: '#3cb4e4', fontSize: '1.5rem' }} />
													</span>
													<span className="d-none d-lg-flex align-self-center m-0">Add/Remove Videos</span>
												</button>
											) : (
												<button onClick={handleReorder}
													className="d-inline-flex align-content-center outline__primary__btn shuffle "
													style={{
														pointerEvents: shuffleClicked ? 'none' : 'auto',
														opacity: shuffleClicked ? 0.5 : 1
													}}>
													<span>
														<EditIcon style={{ color: '#3cb4e4', fontSize: '1.5rem' }} />
													</span>
													<span className="d-none d-lg-flex align-self-center m-0">Edit</span>
												</button>
											)
										)}
										{
											!isReordering ? (
												<button onClick={onShuffle}
													className={`d-inline-flex outline__primary__btn shuffle ${!hasEditAccess ? 'disabled' : ''}`}
													style={{ pointerEvents: !hasEditAccess ? 'none' : 'auto', opacity: !hasEditAccess ? 0.5 : 1 }}>
													<span>
														<ShuffleIcon style={{ color: "#3cb4e4", fontSize: "1.5rem" }} />

													</span>
													<span className="d-none d-lg-flex align-self-center m-0">Shuffle</span>
												</button>
											) : (
												<button onClick={handleSave} className="d-inline-flex text-white align-content-center outline__primary__btn__save shuffle" style={{ backgroundColor: "#3cb4e4" }}>
													<span>
														<SaveIcon style={{ color: "white", fontSize: "1.5rem" }} />
													</span>
													<span className="d-none d-lg-flex align-self-center m-0 fw-normal">Save</span>
												</button>
											)
										}

									</div>
								</div>

								{/* ====== 1 ======== */}
								<div className="col-md-12 p-0">
									{isReordering ? (
										<ReorderPlaylistComponent
											items={displayVideos.map((video, i) => ({ ...video, id: video._id, position: i }))}
											onReorder={(next, updates) => onReorder(next, updates)}
											renderItem={(video) => (
												<div className="mb-2">
													<VideoCardPlaylist
														video={video}
														playlistId={fld?._id}
														isLiked={savedVideos.includes(video._id)}
														viewType={fld?.type}
														fld={fld}
														savedVideos={savedVideos}
														showAddToPlaylist={false}
														handleSaveUnsave={handleSaveUnsave}
														subscriptionStatus={subscriptionStatus}
														handleDeleteVideo={handleDeleteVideo}
														isReordering={isReordering}
													/>
												</div>
											)}
											gap={8}

										/>
									) : (

										<div className="c-video_list-playlist">
											{displayVideos.map((video, index) => (
												<div key={`${video._id}-${index}`} className="mb-2">
													<VideoCardPlaylist
														video={video}
														playlistId={fld._id}
														isLiked={savedVideos.includes(video._id)}
														viewType={fld?.type}
														fld={fld}
														savedVideos={savedVideos}
														showAddToPlaylist={false}
														handleSaveUnsave={handleSaveUnsave}
														subscriptionStatus={subscriptionStatus}
														handleDeleteVideo={handleDeleteVideo}
														isReordering={isReordering}
													/>
												</div>
											))}
										</div>
									)}
								</div>

								{/* ====== 1 ======== */}
							</div>
						</div>
					</div>
				) : (
					'Create your own Studio Playlists now!'
				)}
			</div>
		</>
	);
};

export default DisplayPlaylistVideos;
